import { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import { useNavigate, useLoaderData } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import toast from "react-hot-toast";
import mapboxgl from "mapbox-gl";
import { SearchBox } from "@mapbox/search-js-react";
import "mapbox-gl/dist/mapbox-gl.css";
import "./AvailableBerth.css";
import berthIcon from "../../../../../assets/location.png";
import searchMarker from "../../../../../assets/serach-marker.png";
import RoomIcon from "@mui/icons-material/Room";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { BerthsModal } from "../../../../../components";
import { getAvailableBerths } from "../../../../../services";
import CountUp from "react-countup";
import CircularProgress from "@mui/material/CircularProgress";
const drawerWidth = 240;

export const AvailableBerth = () => {
  const navigate = useNavigate();
  const user = useLoaderData();

  const mapContainerRef = useRef();
  const mapInstanceRef = useRef();
  const markerRef = useRef(null);

  const [isLocationPermissionAllowed, setIsLocationPermissionAllowed] = useState(false);
  const [mapInitializing, setMapInitializing] = useState(true);

  const [mapLoaded, setMapLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [range, setRange] = useState(17);
  const [option, setOption] = useState("hire");
  const [coordinates, setCoordinates] = useState(null);
  const [resultModal, setResultModal] = useState(false);
  const [berths, setBerths] = useState([]);
  const [allBerths, setAllBerths] = useState(null);

  const locationAllowed = async (position) => {
    setIsLocationPermissionAllowed(true);

    const { latitude, longitude } = position.coords;
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_DEFAULT_PUBLIC_TOKEN;

    const map = new mapboxgl.Map({
      container: mapContainerRef.current, // container ID
      center: [longitude, latitude], // starting position [lng, lat]
      zoom: 10, // starting zoom
    });

    mapInstanceRef.current = map;
    mapInstanceRef.current.addControl(new mapboxgl.NavigationControl());

    mapInstanceRef.current.on("load", () => {
      setMapLoaded(true);
    });

    // Create a draggable marker
    const search = document.createElement("img");
    search.src = searchMarker;
    search.alt = "supplier";

    const marker = new mapboxgl.Marker(search, { draggable: true })
      .setLngLat([longitude, latitude])
      .addTo(map);

    // Event listener for marker drag end
    marker.on("dragend", () => {
      const lngLat = marker.getLngLat();
      setCoordinates([lngLat.lng, lngLat.lat]);
    });

    markerRef.current = marker;

    const res = await getAvailableBerths(user?.token);

    const coords = [longitude, latitude];
    setCoordinates(coords);

    if (res?.status === true) {
      setMapInitializing(false);
      setAllBerths(res?.data?.length);
      res?.data?.map((berth) => {
        const el = document.createElement("img");
        el.src = berthIcon;
        el.alt = "berth";

        return new mapboxgl.Marker(el)
          .setLngLat([berth?.currentlongitude, berth?.currentLatitude])
          .setPopup(
            new mapboxgl.Popup({ offset: 15 }) // add popups
              .setHTML(
                `<h3>${berth?.name}</h3><p>${berth?.currentLocation?.name}</p>`
              )
          )
          .addTo(map);
      });

      return;
    }

    if (res?.status === false) {
      setMapInitializing(false);
      if (res?.message === "Invalid or expired access token.") {
        toast.error("Token Expired, please re-login and try");
        return;
      }

      toast.error("Something went wrong pls try again later");
      return;
    }

    setMapInitializing(false);
    toast.error("Something went wrong pls try again later");
    return;
  };

  const locationBlocked = (position) => {
    setIsLocationPermissionAllowed(false);
    setMapInitializing(false);

    toast.error(
      "Please allow location permission to know your current location."
    );
  };

  const loadMap = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        locationAllowed,
        locationBlocked
      );
      return;
    } else {
      toast.error(
        "It seems like Geolocation, which is required for this page, is not enabled in your browser. Please use a browser which supports it."
      );
      return;
    }
  };

  useEffect(() => {
    if (!mapContainerRef.current) {
      return;
    }

    loadMap();
  }, []);

  function validateSearchQuery(query) {
    const regex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s,.\-#/]+$/;

    if (!regex.test(query)) {
      toast.error("Please enter a valid search query.");

      return;
    }

    return query
  }

  const handleSelectedPlace = (e) => {
    if (!isLocationPermissionAllowed) {
      toast.error(
        "Please allow location permission to know your current location for finding berth."
      );
      return;
    }
    if (e.features[0]?.geometry?.coordinates === undefined) {
      toast.error("Please select a valid location from the search results.");
      return;
    }

    setCoordinates(e.features[0]?.geometry?.coordinates);
    const coords = {
      latitude: e.features[0]?.geometry?.coordinates[1],
      longitude: e.features[0]?.geometry?.coordinates[0],
    };
    const obj = {};
    obj.coords = coords;
    // locationAllowed(obj);

    mapInstanceRef.current.flyTo({
      center: e.features[0]?.geometry?.coordinates,
      zoom: 10,
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    })

    if(markerRef.current) {
      markerRef.current.setLngLat(e.features[0]?.geometry?.coordinates);
    }
  };

  const handleSearch = async () => {
    setLoading(true);
    const res = await getAvailableBerths(
      user?.token,
      option === "both" ? "" : option,
      coordinates[1],
      coordinates[0],
      range
    );

    if (res.status === true) {
      setBerths(res?.data);
      setResultModal(true);
      setLoading(false);
      return;
    }

    if (res?.status === false) {
      if (res?.message === "Invalid or expired access token.") {
        setLoading(false);
        toast.error("Token Expired, please re-login and try");
        return;
      }

      if (res?.message === "berth does not exist") {
        setLoading(false);
        toast.error("Berths does not exist in this area range or berth type");
        return;
      }

      setLoading(false);
      toast.error("Something went wrong pls try again later");
      return;
    }

    setLoading(false);
    toast.error("Something went wrong pls try again later");
    return;
  };

  const handleResultModalClose = () => {
    setResultModal(false);
    return;
  };

  return (
    <Box>
      <Typography variant="h3" className="page-title">
        Find Berths
      </Typography>
      <div className="YachtMap">
        <Card>
          <CardContent>
            <Box sx={{ mb: 2 }}>
              <Typography variant="h5">Find available berths</Typography>
              <small>
                <strong>Tip:</strong> Use the searchbox on the below to find the
                available berths in your area.
              </small>
            </Box>
            <Grid container spacing={3} sx={{ mb: 2 }}>
              <Grid item xs={12} md={12} lg={6}>
                <SearchBox
                  placeholder="Port of Amsterdam, Netherlands"
                  autofocus
                  accessToken={
                    process.env.REACT_APP_MAPBOX_DEFAULT_PUBLIC_TOKEN
                  }
                  map={mapInstanceRef.current}
                  mapboxgl={mapboxgl}
                  value={inputValue}
                  onChange={(d) => {
                    setInputValue(d);
                  }}
                  // marker
                  interceptSearch={validateSearchQuery}
                  onRetrieve={(e) => handleSelectedPlace(e)}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={2}>
                <FormControl
                  fullWidth
                  size="small"
                  disabled={coordinates === null}
                >
                  <InputLabel id="lookingFor">Looking to</InputLabel>
                  <Select
                    labelId="lookingFor"
                    id="lookingFor"
                    value={option}
                    label="Looking to"
                    onChange={(e) => setOption(e.target.value)}
                  >
                    <MenuItem value="hire">Hire (rent)</MenuItem>
                    <MenuItem value="swap">Swap</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                    <MenuItem value="sale">Sale</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={2}>
                <FormControl
                  fullWidth
                  size="small"
                  disabled={coordinates === null}
                >
                  <InputLabel id="demo-simple-select-label">
                    Get Berth within
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={range}
                    label="Get Suppliers within"
                    onChange={(e) => setRange(e.target.value)}
                  >
                    <MenuItem value={17}>10 Miles</MenuItem>
                    <MenuItem value={33}>20 Miles</MenuItem>
                    <MenuItem value={81}>50 Miles</MenuItem>
                    <MenuItem value={161}>100 Miles</MenuItem>
                    <MenuItem value={322}>200 Miles</MenuItem>
                    <MenuItem value={805}>500 Miles</MenuItem>
                    <MenuItem value={1610}>1000 Miles</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={2}>
                <Button
                  disabled={coordinates === null}
                  className="theme-btn"
                  variant="contained"
                  onClick={handleSearch}
                  loading={loading}
                  loadingPosition="end"
                >
                  Search
                </Button>
              </Grid>
            </Grid>
            <Typography variant="h6">
              <RoomIcon fontSize="small" /> Currently listed berths{" "}
              {allBerths ? (
                <CountUp start={0} end={allBerths} duration={3} />
              ) : (
                ""
              )}
            </Typography>
            <div className="maps" ref={mapContainerRef} style={{ position: 'relative' }}>
              {mapInitializing && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    zIndex: 1000,
                  }}
                >
                  <CircularProgress color="primary" />
                  <Typography variant="body2" sx={{ mt: 2 }}>Loading map...</Typography>
                </Box>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
      <BerthsModal
        open={resultModal}
        handleClose={handleResultModalClose}
        berths={berths}
      />
    </Box>
  );
};
